// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonAudio_container__Ax5KX","button":"ButtonAudio_button__Fr3Z8","wrapper":"ButtonAudio_wrapper__b42aX"};